// v-click-outside="handler" — calls handler when a pointer goes down anywhere outside the element.
//
// Why not a full-screen `.theme-scrim`: the topbar has `backdrop-filter`, which makes it the
// containing block of every `position:fixed` child, so a scrim inside it only covers the 77px bar —
// clicking the page below never reached it and the bell / theme / language popups stayed open.
// (Same trap documented in MENU_SCROPE.md for the profile sheet.) Put the directive on the wrapper
// that holds BOTH the toggle button and the popup, so pressing the button is not "outside".
const handlers = new WeakMap()

export default {
  mounted(el, binding) {
    const onDown = (e) => {
      if (el.contains(e.target)) return
      if (typeof binding.value === 'function') binding.value(e)
    }
    handlers.set(el, onDown)
    document.addEventListener('pointerdown', onDown, true)
  },
  beforeUnmount(el) {
    document.removeEventListener('pointerdown', handlers.get(el), true)
    handlers.delete(el)
  },
}
